import { Stack } from "@mui/material";
import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatPhone } from "Utils/PhoneUtils";

type Props = {
  contactPerson: PartyDto;
};

export const ContactPersonDetail = ({
  contactPerson: { firstName, lastName, gender, phone, email },
}: Props) => {
  const { t } = useResource();

  const phoneValue = formatPhone(phone);

  return (
    <Stack gap={2}>
      <ValuesBox
        title={t(Resources.Components.Merchant.ContactPersons.Form.Legend)}
      >
        <ValueItems
          values={[
            { label: t(Resources.Common.FirstName), value: firstName },
            { label: t(Resources.Common.LastName), value: lastName },
            { label: t(Resources.Common.Phone), value: phoneValue },
            { label: t(Resources.Common.Email), value: email },
          ]}
        />
      </ValuesBox>
    </Stack>
  );
};
